import React, { useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { ShoppingBag, X } from 'lucide-react';

const stores = [
  {
    name: 'TikTok Shop',
    logo: '/images/shops/1714299153tiktok-shop-logo-transparent.png',
    logoScale: 1.3,
    url: 'https://shop.tiktok.com/mx/pdp/cajeta-natural-hacienda-real-700-gr-dulce-tradicional-sin-conservadores-elaborada-con-de-vaca-sabor-/1734493917997466817',
  },
  {
    name: 'Walmart',
    logo: '/images/shops/Walmart_logo_(2008).svg.png',
    url: 'https://www.walmart.com.mx/ip/cajeta-natural-hacienda-real-700-gr/00017645678905',
  },
  {
    name: 'Bodega Aurrerá',
    logo: '/images/shops/aurrera-2.svg',
    logoScale: 1.8,
    url: 'https://www.bodegaaurrera.com.mx/search?q=Cajeta+Hacienda+Real',
  },
  {
    name: 'Mercado Libre',
    logo: '/images/shops/mercado-libre-logo.png',
    url: 'https://www.mercadolibre.com.mx/p/MLM66925658',
  },
];

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.85) translateY(8px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
`;

const Wrapper = styled.div`
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
`;

const Panel = styled.div`
  background: #FFFDF7;
  border: 1px solid rgba(26,18,8,0.10);
  border-radius: 18px;
  padding: 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 8px 32px rgba(26,18,8,0.13);
  animation: ${fadeIn} 0.22s ease;
  min-width: 160px;
`;

const PanelLabel = styled.p`
  font-family: 'Raleway', sans-serif;
  font-size: 0.62rem;
  letter-spacing: 0.18em;
  color: rgba(26,18,8,0.45);
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4px;
`;

const StoreLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s;
  &:hover { background: rgba(250,243,224,0.8); }
`;

const LogoWrap = styled.div`
  width: 36px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    ${({ $scale }) => $scale && css`transform: scale(${$scale});`}
  }
`;

const StoreName = styled.span`
  font-family: 'Raleway', sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(26,18,8,0.75);
  white-space: nowrap;
`;

const Trigger = styled.button`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: #7C3A00;
  color: #FAF3E0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(124,58,0,0.35);
  transition: background 0.2s, transform 0.2s;
  &:hover { background: #5c2a00; transform: scale(1.07); }
`;

export function ShopsBubble() {
  const [open, setOpen] = useState(false);

  return (
    <Wrapper>
      {open && (
        <Panel>
          <PanelLabel>Comprar en línea</PanelLabel>
          {stores.map((store) => (
            <StoreLink
              key={store.name}
              href={store.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LogoWrap $scale={store.logoScale}>
                <img src={store.logo} alt={store.name} />
              </LogoWrap>
              <StoreName>{store.name}</StoreName>
            </StoreLink>
          ))}
        </Panel>
      )}
      <Trigger onClick={() => setOpen((o) => !o)} aria-label="Dónde comprar">
        {open ? <X size={20} strokeWidth={1.8} /> : <ShoppingBag size={20} strokeWidth={1.8} />}
      </Trigger>
    </Wrapper>
  );
}
